import Template from "./template";

export default {
  element: <Template />,
  loader: async () => {
    return {};
  },
};
